import React, { Component } from 'react';
import PageTitle from './PageTitle';
import BlogWrapper from './BlogWrapper';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import $ from 'jquery';

export default class Blog extends Component {

    constructor(props) {
        super(props);
        this.state = { categories: [], posts: [], begin: 0, end: 6, blocking: false, title: '' };
        this.carregarMais = this.carregarMais.bind(this);
        this.toggleBlocking = this.toggleBlocking.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.procurar = this.procurar.bind(this);

        const requestInfo = {
            method: 'GET',
            headers: new Headers({
                'Content-type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            })
        };

        fetch('http://api.fcsistema.com.br/api-website-fc/categoryPost', requestInfo)
            .then(response => response.json())
            .then(data => {
                this.setState({ categories: data });
            })
            .catch(error => {
                this.setState({ msg: error.message });
            });

        const url = 'http://api.fcsistema.com.br/api-website-fc/post/'
            + (this.props.params.idCategoria != null
                ? 'byCategoria/' + this.props.params.idCategoria + '/' + this.state.begin + "/" + this.state.end
                : this.props.params.title != null
                    ? 'byTitle/' + this.props.params.title + '/' + this.state.begin + "/" + this.state.end
                    : this.state.begin + "/" + this.state.end);

        fetch(url, requestInfo)
            .then(response => response.json())
            .then(data => {
                if (data.length > 0) {
                    this.setState({ posts: data });
                } else {
                    $('#btnCarregarMais').html('nenhum post encontrado.');
                }
            })
            .catch(error => {
                this.setState({ msg: error.message });
            });
    }

    toggleBlocking() {
        this.setState({ blocking: !this.state.blocking });
    }

    handleChange(e) {
        var change = {}
        change[e.target.name] = e.target.value
        this.setState(change)
    }

    carregarMais(event) {
        event.preventDefault();

        var auxInicio = this.state.begin + 4;
        var auxFim = this.state.end + 4;
        this.setState({ begin: auxInicio });
        this.setState({ end: auxFim });

        const requestInfo = {
            method: 'GET',
            headers: new Headers({
                'Content-type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            })
        };

        const url = 'http://api.fcsistema.com.br/api-website-fc/post/'
            + (this.props.params.idCategoria != null
                ? 'byCategoria/' + this.props.params.idCategoria + '/' + auxInicio + "/" + auxFim
                : this.state.title != null
                    ? 'byTitle/' + this.state.title + '/' + auxInicio + "/" + auxFim
                    : auxInicio + "/" + auxFim);

        fetch(url, requestInfo)
            .then(response => response.json())
            .then(data => {
                if (data.length > 0) {
                    this.setState({ posts: this.state.posts.concat(data) });
                } else {
                    $('#btnCarregarMais').html('<p>Mais nenhum post encontrado.</p>');
                }
            })
            .catch(error => {
                this.setState({ msg: error.message });
            });
    }

    procurar(event) {
        event.preventDefault();

        var auxInicio = 0;
        var auxFim = 4;
        this.setState({ begin: auxInicio });
        this.setState({ end: auxFim });

        const requestInfo = {
            method: 'GET',
            headers: new Headers({
                'Content-type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            })
        };

        fetch('http://api.fcsistema.com.br/api-website-fc/post/byTitle/' + this.state.title + '/' + auxInicio + "/" + auxFim, requestInfo)
            .then(response => response.json())
            .then(data => {
                this.setState({ posts: data });
                if (data.length <= 0) {
                    $('#btnCarregarMais').html('<p>Mais nenhum post encontrado.</p>');
                } else {
                    $('#btnCarregarMais').html('Carregar mais posts<i class="material-icons">autorenew</i>');
                }
            })
            .catch(error => {
                this.setState({ msg: error.message });
            });
    }

    render() {
        return (
            <div>
                <PageTitle title="Blog" last="Home" lastLink="/" />
                <section className="section-padding grid-news-hover">
                    <div className="container">

                        <div className="row">
                            <div className="col-md-9">
                                {
                                    this.state.posts.map(post => {
                                        return (
                                            <BlogWrapper id={post.id} width={6} key={post.id} titulo={post.titulo}
                                                resumo={post.resumo} categoria={post.categoria.nome}
                                                dataPublicacao={post.dataPublicacao} imgLink={post.imagemLink} />
                                        );
                                    })
                                }
                            </div>
                            <div className="col-md-3">
                                <div className="tt-sidebar-wrapper" role="complementary">
                                    <div className="widget widget_search">
                                        <form role="search" method="get" className="search-form" onSubmit={this.procurar}>
                                            <input type="text" autoComplete="off" className="form-control" value={this.state.title} onChange={this.handleChange.bind(this)} id="s" name="title" placeholder="Procurar..." />
                                            <button type="submit"><i className="fa fa-search"></i></button>
                                        </form>
                                    </div>
                                    <div className="widget widget_categories">
                                        <h3 className="widget-title">Categorias</h3>
                                        <ul>
                                            {
                                                this.state.categories.map(category => {
                                                    return (<li className={category.id !== this.props.params.idCategoria ? '' : 'active'} key={category.id}><a href={'/blog/' + category.id}>{category.nome}</a></li>);
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <BlockUi tag="div" blocking={this.state.blocking}>
                            <form onSubmit={this.carregarMais}>
                                <div className="row">
                                    <div className="col-md-9">
                                        <div className="input-field align-center col s4">
                                            <button id="btnCarregarMais" className="waves-effect waves-light btn blue" type="submit" name="action">
                                                Carregar mais posts<i className="material-icons">autorenew</i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </BlockUi>

                    </div>
                </section>


            </div >);
    }

}


// WEBPACK FOOTER //
// ./src/components/Blog.js